import {useState} from 'react'

type FieldApi<T> = {
  value: T
  isTouched: boolean
  isVisible: boolean
  changeValue: (nextValue: T) => void
  toggleVisibility: () => void
}

export default function useField<T>(defaultValue: T): FieldApi<T> {
  const [value, setValue] = useState<T>(defaultValue)
  const [isTouched, setIsTouched] = useState<boolean>(false)
  const [isVisible, setVisibility] = useState<boolean>(false)

  const changeValue = (nextValue: T) => {
    setIsTouched(true)
    setValue(nextValue)
  }

  const toggleVisibility = () => setVisibility(v => !v)

  return {
    value,
    isTouched,
    isVisible,
    changeValue,
    toggleVisibility
  }
}
